var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page flex-col"},[_c('img',{staticClass:"image_4",attrs:{"referrerpolicy":"no-referrer","src":require("./assets/img/SketchPng86df24381708c9d2cf8265da9462d9c7945bc0cb9e77c2c4db03865982829c23.png")}})])
}]

export { render, staticRenderFns }